// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__xYE16","overlay":"Header_overlay__KA470","content":"Header_content__jBMFm","image":"Header_image__JkZ+k"};